import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

const biometricsSchema = z.object({
  from: z.coerce.date().optional().catch(undefined),
  to: z.coerce.date().optional().catch(undefined),
  facilities: z.array(z.coerce.number()).optional().catch(undefined),
})

export const Route = createFileRoute("/_app/reports/biometrics/")({
  validateSearch: (search: SearchSchemaInput) => biometricsSchema.parse(search),
})
